import type { schemas } from '@gonfalon/openapi/types';

export type ApprovalRequest = schemas['ApprovalRequestResponse'];
export type ApprovalRequestProgressStatus = 'needs review' | 'approved' | 'declined' | 'failed' | 'completed';

export enum ApprovalRequestStatusEnum {
  APPROVED = 'APPROVED',
  PENDING = 'PENDING',
  DECLINED = 'DECLINED',
  FAILED = 'FAILED',
  COMPLETED = 'COMPLETED',
}
